import { CUSTOM_ELEMENTS_SCHEMA, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, ResolveEnd, RouterLink, RouterLinkActive } from '@angular/router';
import { UserSessionsService } from 'app/shared/services/user-sessions/user-sessions.service';
import { Subject, takeUntil } from 'rxjs';
import { OrchidRouterModule } from '@upmc-healthplan-npm/ods-ng';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [OrchidRouterModule, RouterLink, RouterLinkActive],
})
export class MainMenuComponent implements OnInit, OnDestroy {
  public showAdmin: boolean = false;
  public employeeId: string | null = '';
  public username: string | undefined = '';
  public userService: UserSessionsService = inject(UserSessionsService);
  private router: Router = inject(Router);
  private destroy$ = new Subject<void>();

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.userService.isAdmin.pipe(takeUntil(this.destroy$)).subscribe({
      next: (val) => {
        this.showAdmin = val;
      },
    });
    this.userService.employeeId.pipe(takeUntil(this.destroy$)).subscribe({
      next: (val) => {
        this.employeeId = val;
        setTimeout(() => {
          this.username = this.userService.firstName;
        }, 0);
      },
    });

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe({
      next: (event) => {
        if (event instanceof ResolveEnd) {
          if (event.url == '/login') {
            this.employeeId = null;
            this.showAdmin = false;
          }
        }
      },
    });
  }

  goBack() {
    this.router.navigate(['/home']);
  }

  logout() {
    this.userService.logout();
  }
}
